import commonHelper from '@/app/utility/common.helper.utility';
import URL_UTILITY from '../../../../../../utility/url.utility'
export default {
  name: 'isdDistributionInvoice',
  props: ['isdHeaderData', 'modalType'],
  watch: {
    currentPage: function() {
      if (this.modalType === 'generate') {
        this.getIsdDistributionInvoice();
      } else {
        this.getViewDistributionInvoice();
      }
    },
    perPage: function() {
      if (this.modalType === 'generate') {
        this.currentPage = 1;
        this.getIsdDistributionInvoice();
      } else {
        this.currentPage = 1;
        this.getViewDistributionInvoice();
      }
    },
    selectAllCheckBox: function() {
      this.checkUncheckAll();
    }
  },
  data() {
    return {
      loader: false,
      selectAllCheckBox: false,
      isdDistributionInvoiceData: [],
      isdDistributionInvoiceFields: [
        this.modalType === 'generate'
          ? [
              {
                key: 'select',
                stickyColumn: true,
                variant: 'primary'
              }
            ]
          : [],
        this.modalType !== 'generate'
          ? [
              {
                key: 'invoice_num',
                class: 'text-center',
                label: 'Invoice Number'
              }
            ]
          : [],
        {
          key: 'isd_gstn',
          class: 'text-center',
          label: 'ISD GSTN'
        },
        {
          key: 'recipient_gstn',
          class: 'text-center',
          label: 'RECIPIENT GSTN'
        },
        {
          key: 'dist_period_name',
          class: 'text-center',
          label: 'DISTRIBUTION PERIOD'
        },
        {
          key: 'dist_cgst',
          class: 'text-right',
          label: 'CGST'
        },
        {
          key: 'dist_sgst',
          class: 'text-right',
          label: 'SGST'
        },
        {
          key: 'dist_igst',
          class: 'text-right',
          label: 'IGST'
        },
        {
          key: 'recoverable_flag',
          class: 'text-center'
        },
        this.modalType !== 'generate'
          ? [
              {
                key: 'download',
                class: 'text-center',
                label: 'Download'
              }
            ]
          : []
      ],
      currentPage: 1,
      totalRows: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      requestId: null,
      templateId: null,
      invoiceId: null,
      requestNumId: null,
      dowloadReport: URL_UTILITY.getDownloadReportUrl,
    };
  },
  mounted() {
    if (this.modalType === 'generate') {
      this.getIsdDistributionInvoice();
    } else {
      this.getViewDistributionInvoice();
    }
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && !this.showIsdDistributionDeatilModal) {
          if (this.modalType === 'generate') {
            this.postGenerateIsdDistributionInvoice();
          } else {
            this.getViewDistributionInvoice();
          }
        }
      }
    });
  },
  methods: {
    getIsdDistributionInvoice() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        le_id: this.isdHeaderData[0].LeId,
        period_name: this.isdHeaderData[0].DistPeriodName
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdDistributionInvoice', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.isdDistributionInvoiceData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    checkUncheckAll() {
      this.isdDistributionInvoiceData = this.isdDistributionInvoiceData.map(
        data => {
          data.select = this.selectAllCheckBox;
          return data;
        }
      );
    },
    postGenerateIsdDistributionInvoice() {
      let isdDistributionInvoiceDetails = [];
      const filterInvoiceData = this.isdDistributionInvoiceData.filter(
        data => data.select
      );
      isdDistributionInvoiceDetails = filterInvoiceData.map(item => {
        return {
          invoice_id: 0,
          recoverable_flag: item.recoverable_flag,
          dist_period_name: item.dist_period_name,
          dist_cgst: item.dist_cgst,
          dist_sgst: item.dist_sgst,
          dist_igst: item.dist_igst,
          isd_gstn: item.isd_gstn,
          recipient_gstn: item.recipient_gstn
        };
      });
      const payload = {
        gst_ist_dist_inv_dtls: isdDistributionInvoiceDetails
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/postGenerateIsdDistributionInvoice', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 201) {
            this.$bvToast.toast(response.data.message, {
              title: 'Alert',
              variant: 'success',
              solid: true
            });
          } else {
            this.loader = false;
            this.$bvToast.toast(response.response.data.message, {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch(err => {
          this.err = err;
          this.loader = false;
        });
    },
    getViewDistributionInvoice() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        period_name: this.isdHeaderData[0].DistPeriodName,
        recipient_gstn: ''
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getViewDistributionInvoice', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.isdDistributionInvoiceData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    printInvoiceForDistribution(item) {
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/printInvoiceForDistribution')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const reslut = response.data.data;
            (this.templateId = reslut.template_id),
              (this.requestId = reslut.request_id);
            this.invoiceId = item.invoice_id;
            this.saveSubmitRequest();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    saveSubmitRequest() {
      const payload = {
        admin_submit_req_details: [
          {
            request_num: 0,
            request_id: this.requestId,
            template_id: this.templateId,
            schedule_type: 'asap', //pass hardcode
            request_start_date: null,
            request_end_date: null,
            resubmit_interval: null,
            resubmit_interval_unit: null,
            day_of_month: null,
            day_of_week: null,
            output_format_id: 'PDF', //pass hardcode
            no_of_args: 25,
            request_parameter: this.invoiceId,
            sms_flag: false,
            email_flag: false,
            whatsapp_flag: false,
            child_req_count: null,
            email_comm_template_id: null,
            sms_comm_template_id: null,
            whatsapp_comm_template_id: null,
            argument1: this.invoiceId,
            argument2: null,
            argument3: null,
            argument4: null,
            argument5: null,
            argument6: null,
            argument7: null,
            argument8: null,
            argument9: null,
            argument10: null,
            argument11: null,
            argument12: null,
            argument13: null,
            argument14: null,
            argument15: null,
            argument16: null,
            argument17: null,
            argument18: null,
            argument19: null,
            argument20: null,
            argument21: null,
            argument22: null,
            argument23: null,
            argument24: null,
            argument25: null
          }
        ]
      };
      this.loader = true;
      this.$store
        .dispatch('template/saveSubmitRequest', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 201) {
            this.requestNumId = resp.data.data[0].id;
            this.getSubmitRequest();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getSubmitRequest() {
      this.loader = true;
      this.$store
        .dispatch('template/getSubmitRequest', this.requestNumId)
        .then(resp => {
          if (resp.status === 200) {
            this.requestStatus = resp.data.data[0].status;
            this.reqId = resp.data.data[0].id;
            if (this.requestStatus !== 'COMPLETED') {
              this.loader = true;
              setTimeout(() => {
                this.getSubmitRequest();
              }, 5000);
            } else {
              this.loader = false;
              this.downloadReport();
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    downloadReport() {
      window.location.href = this.dowloadReport + '/' + this.requestNumId;
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
